export default __webpack_public_path__ + "static/media/ai2.ff50480c.png";